import React from 'react';
import { CustomSVG } from '../../CustomSVG/CustomSVG';
import TagSvg from '../../../assets/icons/app/tag.svg?raw';

export const TagIcon = (props) => <CustomSVG svg={TagSvg} preserveColors appIconSmall {...props} />;
